module.exports = __webpack_public_path__ + "media/images/lp_v6_arw1-cb73be3810404a6a617dc37058603065.webp";